<template>
  <div
    class="age-verification-pill inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/40 pl-3 sm:pl-4 pr-1 py-1 max-w-full"
  >
    <span v-if="error" class="text-sm text-red-400 whitespace-nowrap">
      {{ error }}
    </span>
    <template v-else>
      <span class="text-sm text-white/80 whitespace-nowrap hidden xl:inline">
        Unlock full previews — confirm you're 18+
      </span>
      <span class="text-sm text-white/80 whitespace-nowrap xl:hidden">
        Unlock full previews
      </span>
    </template>
    <button
      type="button"
      class="rounded-full bg-sky-300 hover:bg-sky-200 text-black text-sm font-semibold px-3 py-1 whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
      :disabled="loading"
      @click="startVerification"
    >
      {{ loading ? "…" : "I'm 18+" }}
    </button>
  </div>
</template>

<script setup>
  const route = useRoute()
  const loading = ref(false)
  const error = ref(null)

  const startVerification = async () => {
    loading.value = true
    error.value = null
    try {
      const response = await $fetch("/api/age-verification/session", {
        method: "POST",
        body: { returnTo: route.fullPath },
      })
      if (response?.verifyUrl) {
        window.location.href = response.verifyUrl
        return
      }
      error.value = "Verification unavailable — try again later."
    } catch {
      error.value = "Verification unavailable — try again later."
    } finally {
      loading.value = false
    }
  }
</script>
